import { render, staticRenderFns } from "./FormLayoutGroup.vue?vue&type=template&id=2c59bc5e&"
import script from "./FormLayoutGroup.vue?vue&type=script&lang=js&"
export * from "./FormLayoutGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormLayoutGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports